export const PREVIOUSLY_RELEASED_AGENT_VERSIONS = {
	development: [
		{ agentVersion: '1.4.2-b', releaseDate: 1777014696177 },
		{ agentVersion: '1.4.2-a', releaseDate: 1776133964430 },
		{ agentVersion: '1.4.2', releaseDate: 1776054239404 },
		{ agentVersion: '1.4.0-o', releaseDate: 1776052348741 },
		{ agentVersion: '1.4.0-n', releaseDate: 1774853682558 },
		{ agentVersion: '1.4.0-m', releaseDate: 1774843628681 },
		{ agentVersion: '1.4.0-l', releaseDate: 1774837791869 },
		{ agentVersion: '1.4.0-k', releaseDate: 1767667922402 },
		{ agentVersion: '1.4.0-j', releaseDate: 1767665582274 },
		{ agentVersion: '1.4.0-h', releaseDate: 1767634436595 },
		{ agentVersion: '1.4.0-g', releaseDate: 1767323213056 },
		{ agentVersion: '1.4.0-f', releaseDate: 1767078054182 },
		{ agentVersion: '1.4.0-e', releaseDate: 1756185088748 },
		{ agentVersion: '1.4.0-d', releaseDate: 1752029308033 },
		{ agentVersion: '1.4.0-c', releaseDate: 1751969378012 },
		{ agentVersion: '1.4.0-b', releaseDate: 1751536999551 },
		{ agentVersion: '1.4.0-a', releaseDate: 1751526626723 },
		{ agentVersion: '1.4.0', releaseDate: 1751440242290 },
		{ agentVersion: '1.3.0-c', releaseDate: 1750911629288 },
		{ agentVersion: '1.3.0-b', releaseDate: 1747644458976 },
		{ agentVersion: '1.3.0-a', releaseDate: 1747298316351 },
		{ agentVersion: '1.3.0.10', releaseDate: 1747210856503 },
		{ agentVersion: '1.3.0.9', releaseDate: 1747208052228 },
		{ agentVersion: '1.3.0.8', releaseDate: 1747206670618 },
		{ agentVersion: '1.3.0.7', releaseDate: 1747205749468 },
		{ agentVersion: '1.3.0.6', releaseDate: 1747192254125 },
		{ agentVersion: '1.3.0.5', releaseDate: 1747159992491 },
		{ agentVersion: '1.3.0.4', releaseDate: 1747131280013 },
		{ agentVersion: '1.3.0.3', releaseDate: 1747120535780 },
		{ agentVersion: '1.3.0.2', releaseDate: 1747106800125 },
		{ agentVersion: '1.3.0.1', releaseDate: 1747038146940 },
		{ agentVersion: '1.3.26', releaseDate: 1746776191402 },
		{ agentVersion: '1.3.25', releaseDate: 1745832398839 },
		{ agentVersion: '1.3.23', releaseDate: 1745316644970 },
		{ agentVersion: '1.3.22', releaseDate: 1745260381593 },
		{ agentVersion: '1.3.21', releaseDate: 1745258109936 },
		{ agentVersion: '1.3.20', releaseDate: 1745257919173 },
		{ agentVersion: '1.3.19', releaseDate: 1745249183913 },
		{ agentVersion: '1.3.18', releaseDate: 1745228387046 },
		{ agentVersion: '1.3.17', releaseDate: 1742888789297 },
		{ agentVersion: '1.3.16', releaseDate: 1742185870067 },
		{ agentVersion: '1.3.15', releaseDate: 1741947350483 },
		{ agentVersion: '1.3.14', releaseDate: 1741848429520 },
		{ agentVersion: '1.3.13', releaseDate: 1741751150422 },
		{ agentVersion: '1.3.12', releaseDate: 1741577878176 },
		{ agentVersion: '1.3.11', releaseDate: 1741317940563 },
		{ agentVersion: '1.3.1', releaseDate: 1741227927885 },
		{ agentVersion: '1.3.0', releaseDate: 1741143299697 },
		{ agentVersion: '1.2.92', releaseDate: 1741142098933 },
		{ agentVersion: '1.2.91', releaseDate: 1711737469983 },
		{ agentVersion: '1.2.90', releaseDate: 1711718080231 },
		{ agentVersion: '1.2.89', releaseDate: 1711576289629 },
		{ agentVersion: '1.2.88', releaseDate: 1711571675492 },
		{ agentVersion: '1.2.87', releaseDate: 1711566859164 },
		{ agentVersion: '1.2.85', releaseDate: 1711555542050 },
		{ agentVersion: '1.2.84', releaseDate: 1711551838298 },
		{ agentVersion: '1.2.83', releaseDate: 1711492630121 },
		{ agentVersion: '1.2.82', releaseDate: 1711482294509 },
		{ agentVersion: '1.2.81', releaseDate: 1711468247661 },
		{ agentVersion: '1.2.80', releaseDate: 1711408114567 },
		{ agentVersion: '1.2.79', releaseDate: 1711386253925 },
		{ agentVersion: '1.2.78', releaseDate: 1711134646006 },
		{ agentVersion: '1.2.77', releaseDate: 1711064783134 },
		{ agentVersion: '1.2.76', releaseDate: 1711043069925 },
		{ agentVersion: '1.2.75', releaseDate: 1711008684252 },
		{ agentVersion: '1.2.74', releaseDate: 1710956638754 },
		{ agentVersion: '1.2.73', releaseDate: 1710882865004 },
		{ agentVersion: '1.2.72', releaseDate: 1710882015671 },
		{ agentVersion: '1.2.71', releaseDate: 1710881623249 },
		{ agentVersion: '1.2.70', releaseDate: 1710879979669 },
		{ agentVersion: '1.2.69', releaseDate: 1710866059093 },
		{ agentVersion: '1.2.68', releaseDate: 1710277615827 },
		{ agentVersion: '1.2.67', releaseDate: 1709935423281 },
		{ agentVersion: '1.2.66', releaseDate: 1701106970292 },
		{ agentVersion: '1.2.65', releaseDate: 1693511852007 },
		{ agentVersion: '1.2.64', releaseDate: 1693497131684 },
		{ agentVersion: '1.2.63', releaseDate: 1693338059638 },
		{ agentVersion: '1.2.62', releaseDate: 1693337653932 },
		{ agentVersion: '1.2.61', releaseDate: 1693335129980 },
		{ agentVersion: '1.2.60', releaseDate: 1693237284287 },
		{ agentVersion: '1.2.58', releaseDate: 1691421260378 },
		{ agentVersion: '1.2.56', releaseDate: 1691416232527 },
		{ agentVersion: '1.2.55', releaseDate: 1691077447798 },
		{ agentVersion: '1.2.53', releaseDate: 1691008351697 },
		{ agentVersion: '1.2.52', releaseDate: 1691008206257 },
		{ agentVersion: '1.2.51', releaseDate: 1691006275411 },
		{ agentVersion: '1.2.50', releaseDate: 1691005775000 },
		{ agentVersion: '1.2.49', releaseDate: 1690815984870 },
		{ agentVersion: '1.2.48', releaseDate: 1690478584590 },
		{ agentVersion: '1.2.47', releaseDate: 1690467208804 },
		{ agentVersion: '1.2.46', releaseDate: 1690417823979 },
		{ agentVersion: '1.2.45', releaseDate: 1690408509359 },
		{ agentVersion: '1.2.44', releaseDate: 1690400284897 },
		{ agentVersion: '1.2.43', releaseDate: 1690400149654 },
		{ agentVersion: '1.2.42', releaseDate: 1690399332812 },
		{ agentVersion: '1.2.41', releaseDate: 1689960395736 },
		{ agentVersion: '1.2.40', releaseDate: 1689868073850 },
		{ agentVersion: '1.2.39', releaseDate: 1689704233104 },
		{ agentVersion: '1.2.38', releaseDate: 1689703164258 },
		{ agentVersion: '1.2.37', releaseDate: 1688941412618 },
		{ agentVersion: '1.2.36', releaseDate: 1688937231128 },
		{ agentVersion: '1.2.35', releaseDate: 1688911888254 },
		{ agentVersion: '1.2.34', releaseDate: 1688838295299 },
		{ agentVersion: '1.2.33', releaseDate: 1688836843183 },
		{ agentVersion: '1.2.32', releaseDate: 1688830379047 },
		{ agentVersion: '1.2.31', releaseDate: 1688759236103 },
		{ agentVersion: '1.2.29', releaseDate: 1684955408030 },
		{ agentVersion: '1.2.28', releaseDate: 1684865034774 },
		{ agentVersion: '1.2.27', releaseDate: 1684854747190 },
		{ agentVersion: '1.2.26', releaseDate: 1684348081377 },
		{ agentVersion: '1.2.25', releaseDate: 1683898597480 },
		{ agentVersion: '1.2.24', releaseDate: 1683573454636 },
		{ agentVersion: '1.2.23', releaseDate: 1683507313244 },
		{ agentVersion: '1.2.22', releaseDate: 1683231041546 },
		{ agentVersion: '1.2.21', releaseDate: 1683124791649 },
		{ agentVersion: '1.2.20', releaseDate: 1683054299014 },
		{ agentVersion: '1.2.19', releaseDate: 1683043138048 },
		{ agentVersion: '1.2.18', releaseDate: 1682870332057 },
		{ agentVersion: '1.2.17', releaseDate: 1682812534114 },
		{ agentVersion: '1.2.16', releaseDate: 1682786996925 },
		{ agentVersion: '1.2.15', releaseDate: 1682634271005 },
		{ agentVersion: '1.2.13', releaseDate: 1682619133790 },
		{ agentVersion: '1.2.12', releaseDate: 1682618407284 },
		{ agentVersion: '1.2.11', releaseDate: 1682524677002 },
		{ agentVersion: '1.2.10', releaseDate: 1682519218013 },
		{ agentVersion: '1.2.8', releaseDate: 1682364833033 },
		{ agentVersion: '1.2.7', releaseDate: 1682120535594 },
		{ agentVersion: '1.2.6', releaseDate: 1682023651527 },
		{ agentVersion: '1.2.5', releaseDate: 1681997234895 },
		{ agentVersion: '1.2.4', releaseDate: 1681754547564 },
		{ agentVersion: '1.2.2', releaseDate: 1680802462441 },
		{ agentVersion: '1.2.1', releaseDate: 1679690449073 },
		{ agentVersion: '1.1.99', releaseDate: 1679667342232 },
		{ agentVersion: '1.1.96', releaseDate: 1661898355996 },
		{ agentVersion: '1.1.98', releaseDate: 1661823456789 },
		{ agentVersion: '1.1.97', releaseDate: 1661812345678 },
		{ agentVersion: '1.1.95', releaseDate: 1661800359546 },
		{ agentVersion: '1.1.94', releaseDate: 1661302839917 },
		{ agentVersion: '1.1.93', releaseDate: 1661264726965 },
		{ agentVersion: '1.1.92', releaseDate: 1661202695932 },
		{ agentVersion: '1.1.90', releaseDate: 1653432479102 },
		{ agentVersion: '1.1.89', releaseDate: 1649947894375 },
		{ agentVersion: '1.1.88', releaseDate: 1649436639328 },
		{ agentVersion: '1.1.87', releaseDate: 1645739357206 },
		{ agentVersion: '1.1.86', releaseDate: 1645632831893 },
		{ agentVersion: '1.1.84', releaseDate: 1645030736409 },
		{ agentVersion: '1.1.83', releaseDate: 1645025389996 },
		{ agentVersion: '1.1.82', releaseDate: 1644991144273 },
		{ agentVersion: '1.1.81', releaseDate: 1644935529112 },
		{ agentVersion: '1.1.80', releaseDate: 1644880221706 },
		{ agentVersion: '1.1.79', releaseDate: 1644851965082 },
		{ agentVersion: '1.1.78', releaseDate: 1644619887372 },
		{ agentVersion: '1.1.77', releaseDate: 1644618910337 },
		{ agentVersion: '1.1.76', releaseDate: 1644588107022 },
		{ agentVersion: '1.1.75', releaseDate: 1644554308046 },
		{ agentVersion: '1.1.74', releaseDate: 1644532212676 },
		{ agentVersion: '1.1.71', releaseDate: 1644507906069 },
		{ agentVersion: '1.1.70', releaseDate: 1644500515705 },
		{ agentVersion: '1.1.67', releaseDate: 1643961460450 },
		{ agentVersion: '1.1.66', releaseDate: 1643918081881 },
		{ agentVersion: '1.1.65', releaseDate: 1643817712542 },
		{ agentVersion: '1.1.64', releaseDate: 1643767595020 },
		{ agentVersion: '1.1.63', releaseDate: 1643405951214 },
		{ agentVersion: '1.1.61', releaseDate: 1642708373228 },
		{ agentVersion: '1.1.60', releaseDate: 1642626629841 },
		{ agentVersion: '1.1.59', releaseDate: 1642613536039 },
		{ agentVersion: '1.1.58', releaseDate: 1642612854781 },
		{ agentVersion: '1.1.57', releaseDate: 1642545513436 },
		{ agentVersion: '1.1.56', releaseDate: 1642544530288 },
		{ agentVersion: '1.1.55', releaseDate: 1642543382738 },
		{ agentVersion: '1.1.54', releaseDate: 1642465602046 },
		{ agentVersion: '1.1.53', releaseDate: 1642372375382 },
		{ agentVersion: '1.1.52', releaseDate: 1642371441995 },
		{ agentVersion: '1.1.51', releaseDate: 1642209680158 },
		{ agentVersion: '1.1.50', releaseDate: 1642199323469 },
		{ agentVersion: '1.1.48', releaseDate: 1634737157229 },
		{ agentVersion: '1.1.47', releaseDate: 1634669295652 },
		{ agentVersion: '1.1.46', releaseDate: 1634651922902 },
		{ agentVersion: '1.1.45', releaseDate: 1634649644475 },
		{ agentVersion: '1.1.44', releaseDate: 1634590796023 },
		{ agentVersion: '1.1.43', releaseDate: 1634590255753 },
		{ agentVersion: '1.1.42', releaseDate: 1634564309640 },
		{ agentVersion: '1.1.41', releaseDate: 1634233655987 },
		{ agentVersion: '1.1.40', releaseDate: 1634215163772 },
		{ agentVersion: '1.1.39', releaseDate: 1633553338391 },
		{ agentVersion: '1.1.38', releaseDate: 1633380347528 },
		{ agentVersion: '1.1.37', releaseDate: 1632842457208 },
		{ agentVersion: '1.1.36', releaseDate: 1632842391567 },
		{ agentVersion: '1.1.35', releaseDate: 1632710163927 },
		{ agentVersion: '1.1.33', releaseDate: 1630419994410 },
		{ agentVersion: '1.1.32', releaseDate: 1630419758787 },
		{ agentVersion: '1.1.30', releaseDate: 1629928770239 },
		{ agentVersion: '1.1.29', releaseDate: 1629925750993 },
		{ agentVersion: '1.1.28', releaseDate: 1629866173467 },
		{ agentVersion: '1.1.27', releaseDate: 1628714440219 },
		{ agentVersion: '1.1.26', releaseDate: 1628190050763 },
		{ agentVersion: '1.1.25', releaseDate: 1628188891819 },
		{ agentVersion: '1.1.24', releaseDate: 1628186444189 },
		{ agentVersion: '1.1.23', releaseDate: 1628185462039 },
		{ agentVersion: '1.1.20', releaseDate: 1626716705713 },
		{ agentVersion: '1.1.19', releaseDate: 1626289486249 },
		{ agentVersion: '1.1.15', releaseDate: 1624554382694 },
		{ agentVersion: '1.1.14', releaseDate: 1624554382693 },
		{ agentVersion: '1.1.14.1', releaseDate: 1624554382000 },
		{ agentVersion: '1.1.13', releaseDate: 1624459502264 },
		{ agentVersion: '1.1.12', releaseDate: 1624459085232 },
		{ agentVersion: '1.1.11', releaseDate: 1624457234569 },
		{ agentVersion: '1.1.8', releaseDate: 1624031530588 },
		{ agentVersion: '1.1.10', releaseDate: 1624031530587 },
		{ agentVersion: '1.1.9', releaseDate: 1623102456341 },
		{ agentVersion: '1.1.7', releaseDate: 1621277829300 },
		{ agentVersion: '1.1.6', releaseDate: 1621277245161 },
		{ agentVersion: '1.1.5', releaseDate: 1617309013494 },
		{ agentVersion: '1.1.4', releaseDate: 1617052694189 },
		{ agentVersion: '1.1.3', releaseDate: 1616441851366 },
		{ agentVersion: '1.1.2', releaseDate: 1616010297861 },
		{ agentVersion: '1.1.1', releaseDate: 1615585578901 },
		{ agentVersion: '1.1.0', releaseDate: 1615562067775 },
		{ agentVersion: '1.0.59', releaseDate: 1615398920701 },
		{ agentVersion: '1.0.58', releaseDate: 1615227926263 },
		{ agentVersion: '1.0.57', releaseDate: 1615221157196 },
		{ agentVersion: '1.0.56', releaseDate: 1615220620158 },
		{ agentVersion: '1.0.55', releaseDate: 1614985451495 },
		{ agentVersion: '1.0.54', releaseDate: 1614980047453 },
		{ agentVersion: '1.0.53', releaseDate: 1614979610561 },
		{ agentVersion: '1.0.52', releaseDate: 1614979067947 },
		{ agentVersion: '1.0.51', releaseDate: 1614970089379 },
		{ agentVersion: '1.0.50', releaseDate: 1614736679855 },
		{ agentVersion: '1.0.49', releaseDate: 1614731535608 },
		{ agentVersion: '1.0.48', releaseDate: 1614729248294 },
		{ agentVersion: '1.0.47', releaseDate: 1614728933347 },
		{ agentVersion: '1.0.46', releaseDate: 1614728612922 },
		{ agentVersion: '1.0.45', releaseDate: 1614711169320 },
		{ agentVersion: '1.0.44', releaseDate: 1614707449662 },
		{ agentVersion: '1.0.43', releaseDate: 1614319831822 },
		{ agentVersion: '1.0.42', releaseDate: 1614311955916 },
		{ agentVersion: '1.0.41', releaseDate: 1614281058164 },
		{ agentVersion: '1.0.40', releaseDate: 1614051613171 },
		{ agentVersion: '1.0.39', releaseDate: 1614047226732 },
		{ agentVersion: '1.0.38', releaseDate: 1614028465680 },
		{ agentVersion: '1.0.37', releaseDate: 1613721921608 },
		{ agentVersion: '1.0.36', releaseDate: 1613681517242 },
		{ agentVersion: '1.0.35', releaseDate: 1613638495275 },
		{ agentVersion: '1.0.34', releaseDate: 1613638413337 },
		{ agentVersion: '1.0.33', releaseDate: 1613638290669 },
		{ agentVersion: '1.0.32', releaseDate: 1613638132772 },
		{ agentVersion: '1.0.31', releaseDate: 1613637128989 },
		{ agentVersion: '1.0.30', releaseDate: 1613634369396 },
		{ agentVersion: '1.0.29', releaseDate: 1613463812935 },
		{ agentVersion: '1.0.28', releaseDate: 1613463076936 },
		{ agentVersion: '1.0.27', releaseDate: 1613462752746 },
		{ agentVersion: '1.0.26', releaseDate: 1613462593097 },
		{ agentVersion: '1.0.25', releaseDate: 1613462308874 },
		{ agentVersion: '1.0.24', releaseDate: 1613461171550 },
		{ agentVersion: '1.0.23', releaseDate: 1613460981487 },
		{ agentVersion: '1.0.22', releaseDate: 1613008035672 },
		{ agentVersion: '1.0.21', releaseDate: 1613005029390 },
		{ agentVersion: '1.0.20', releaseDate: 1612942964324 },
		{ agentVersion: '1.0.19', releaseDate: 1612932201706 },
		{ agentVersion: '1.0.18', releaseDate: 1612929792299 },
		{ agentVersion: '1.0.17', releaseDate: 1612872076804 },
		{ agentVersion: '1.0.16', releaseDate: 1612871748325 },
		{ agentVersion: '1.0.15', releaseDate: 1612869803057 },
		{ agentVersion: '1.0.14', releaseDate: 1612867571942 },
		{ agentVersion: '1.0.12', releaseDate: 1612864758494 },
		{ agentVersion: '1.0.11', releaseDate: 1612864474014 },
		{ agentVersion: '1.0.10', releaseDate: 1612861072378 },
		{ agentVersion: '1.0.9', releaseDate: 1612823631833 },
		{ agentVersion: '1.0.8', releaseDate: 1612798133335 },
		{ agentVersion: '1.0.7', releaseDate: 1612797931634 },
		{ agentVersion: '1.0.6', releaseDate: 1612796905030 },
		{ agentVersion: '1.0.5', releaseDate: 1612796498306 },
		{ agentVersion: '1.0.4', releaseDate: 1612794752261 },
		{ agentVersion: '1.0.3', releaseDate: 1603828602983 },
		{ agentVersion: '1.1.3.1', releaseDate: 0 },
		{ agentVersion: '1.1.3.2', releaseDate: 0 },
		{ agentVersion: '1.1.3.3', releaseDate: 0 },
		{ agentVersion: '1.1.3.4', releaseDate: 0 },
		{ agentVersion: '1.1.33-test', releaseDate: 0 }
	],
	staging: [],
	production: [
		{ agentVersion: '1.4.1', releaseDate: 1774060377544 },
		{ agentVersion: '1.4.0', releaseDate: 1756521764031 },
		{ agentVersion: '1.3.0', releaseDate: 1748059536183 },
		{ agentVersion: '1.2.90', releaseDate: 1711995188513 },
		{ agentVersion: '1.2.65', releaseDate: 1696609835446 },
		{ agentVersion: '1.2.58', releaseDate: 1691690994027 },
		{ agentVersion: '1.2.29', releaseDate: 1685639565375 },
		{ agentVersion: '1.2.26', releaseDate: 1684945885526 },
		{ agentVersion: '1.2.1', releaseDate: 1680032313917 },
		{ agentVersion: '1.1.96', releaseDate: 1662064378928 },
		{ agentVersion: '1.1.90', releaseDate: 1654112345000 },
		{ agentVersion: '1.1.89', releaseDate: 1650632680640 },
		{ agentVersion: '1.1.87', releaseDate: 1646074554113 },
		{ agentVersion: '1.1.63', releaseDate: 1643408682487 },
		{ agentVersion: '1.1.61', releaseDate: 1643056074637 },
		{ agentVersion: '1.1.17', releaseDate: 1625174455762 },
		{ agentVersion: '1.1.9', releaseDate: 1625062734653 }
	]
};
